import {ValueObject} from '@s-ui/domain'

export class GetCloseDealersRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {InstantOfferEntity} param.instantOfferEntity
   * @param {Boolean} param.isNextAppointment
   */

  static validate({instantOfferEntity, invalidRequestErrorFactory}) {
    if (!instantOfferEntity.getId()) throw invalidRequestErrorFactory('instantOfferId is required')
  }

  getInstantOfferId() {
    return this._instantOfferEntity.getId()
  }

  isNextAppointment() {
    return this._isNextAppointment
  }
}
